window.addEventListener("load", function () {
    setTimeout(function () {
        document.querySelector(".loader-wrapper").style.display = "none";
        document.body.classList.remove("no-scroll");
    }, 100);
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById("read-more-toggle");
  const hiddenParagraphs = document.querySelectorAll(".about-pro-content .hide-p");

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function (e) {
      e.preventDefault(); // Stop page from jumping up

      // Check if the paragraphs are currently shown
      const isExpanded = hiddenParagraphs[0].classList.contains("show");

      hiddenParagraphs.forEach(p => {
        p.classList.toggle("show");
      });

      // Toggle the link text
      if (isExpanded) {
        toggleBtn.textContent = "Read More...";
      } else {
        toggleBtn.textContent = "Read Less...";
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (toggleBtn && mobileMenu) {
    toggleBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
    });
  }
});

/* =====================================================
   NATURAL CRUSH — JavaScript
   ===================================================== */

document.addEventListener('DOMContentLoaded', () => {

/* =====================================================
   1. LENIS — Smooth Scroll (Lerp Mode - Ultra Fast)
   ===================================================== */
let lenis;
if (typeof Lenis !== 'undefined') {
  lenis = new Lenis({
   duration: 1.8, // Reduced from 1.4 for a much faster response
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -14 * t)), // Harder deceleration curve
    wheelMultiplier: 1.2,  // Keeps input 1:1 with native browser speed
    smoothWheel: true,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
}
  /* =====================================================
     2. AOS — Animate On Scroll
     ===================================================== */
  AOS.init({
    duration: 800,
    easing: 'ease-out-cubic',
    once: true,
    offset: 80,
  });

/* =====================================================
   2.5 GSAP — Split Text Animation (FIXED RESPONSIVE)
   ===================================================== */
/* =====================================================
   2.5 GSAP — Split Text Animation (FIXED WITH SPACES)
   ===================================================== */
const splitBpHeadingText = (heading) => {
  // Split the text content into arrays of words, keeping track of layout
  const words = heading.innerHTML.trim().split(/\s+/);
  
  heading.innerHTML = words.map((word) => {
    // Preserve manual HTML line breaks if they exist in the heading text
    if (word.toLowerCase() === '<br>' || word.toLowerCase() === '<br/>') {
      return '<br />';
    } 

    // Split the current word into individual letter elements
    const letters = word.split('').map((char) => {
      return `<span class="bp-letter">${char}</span>`;
    }).join('');

    // Wrap the letters into a word container, adding a structural space right after it
    return `<span class="bp-word">${letters}</span><span class="bp-word-space">&nbsp;</span>`;
  }).join(''); // Merged tightly because spacing is handled structurally above
};

if (typeof gsap !== 'undefined') {
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  const bpHeadings = document.querySelectorAll('.bp-heading');
  
  bpHeadings.forEach((heading) => {
    splitBpHeadingText(heading);
    const letters = heading.querySelectorAll('.bp-letter');

    gsap.from(letters, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      ease: 'power3.out',
      stagger: 0.03,
      rotationX: 15,
      transformOrigin: 'center bottom',
      scrollTrigger: {
        trigger: heading,
        start: 'top 80%',
        toggleActions: 'play pause resume pause',
      },
    });
  });
}

/* =====================================================
   3. GSAP — BANNER HEADING (With Website Loader)
   ===================================================== */

// 1. Simulated/Actual Website Loader Trigger
window.addEventListener("load", () => {
  // Replace this timeout with your actual loader's "onComplete" callback
  setTimeout(() => {
    initHeroAnimation();
  }, 1000); 
});

// 2. The Animation Function
function initHeroAnimation() {
  const heroTitle = document.querySelector(".hero-title");
  if (!heroTitle) return; // Guard clause in case the element isn't on the page

  // Make the title visible now that JS is ready to take over
  heroTitle.classList.add("ready");

  // 3. Splitting text safely while preserving nested structural elements like <span class="gold-text">
  const originalHTML = heroTitle.innerHTML;
  
  // Custom split regex that safely captures HTML tags or raw words
  const tokens = originalHTML.match(/(<[^>]+>|[^<>\s]+|\s+)/g) || [];
  
  let newHTML = "";
  let insideGoldSpan = false;

  tokens.forEach(token => {
    // If it's a structural tag, preserve it
    if (token.startsWith("<")) {
      if (token.includes("gold-text")) insideGoldSpan = true;
      if (token.includes("/span")) insideGoldSpan = false;
      newHTML += token;
    } 
    // If it's pure empty spacing, leave it alone
    else if (token.trim() === "") {
      newHTML += token;
    } 
    // If it's a word, wrap it for the mask effect
    else {
      const goldClass = insideGoldSpan ? ' gold-text' : '';
      newHTML += `
        <span class="word-wrapper">
          <span class="word-child${goldClass}">${token}</span>
        </span>`;
    }
  });
  
  heroTitle.innerHTML = newHTML;

  // 4. The GSAP Timeline Animation
  const tl = gsap.timeline();

  tl.from(".hero-title .word-child", {
    y: "100%",            // Pull up from hidden wrapper bounds
    rotateX: 35,          // Sleek 3D angle dynamic
    opacity: 0,
    duration: 1.2,
    ease: "power4.out",
    stagger: 0.15         // Smooth word-by-word sequence
  });
}
  /* =====================================================
     3. NAVBAR — Scroll Effect
     ===================================================== */
  const header = document.getElementById('navbar');

  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Also hook into Lenis scroll if available
    if (lenis) {
      lenis.on('scroll', ({ scroll }) => {
        header.classList.toggle('scrolled', scroll > 60);
      });
    }
  }


  /* =====================================================
     4. HAMBURGER MENU (Custom — no Bootstrap dependency)
     ===================================================== */
  const hamburger   = document.getElementById('hamburger');
  const mobileMenu  = document.getElementById('mobileMenu');
  const mobileLinks = document.querySelectorAll('.mobile-link');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      const isOpen = mobileMenu.classList.contains('open');
      hamburger.setAttribute('aria-expanded', isOpen);

      // Animate hamburger spans
      const spans = hamburger.querySelectorAll('span');
      if (isOpen) {
        spans[0].style.transform = 'translateY(7px) rotate(45deg)';
        spans[1].style.opacity   = '0';
        spans[2].style.transform = 'translateY(-7px) rotate(-45deg)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity   = '';
        spans[2].style.transform = '';
      }
    });

    // Close menu on link click
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        const spans = hamburger.querySelectorAll('span');
        spans[0].style.transform = '';
        spans[1].style.opacity   = '';
        spans[2].style.transform = '';
      });
    });
  }


  /* =====================================================
     5. SLICK SLIDER — Products
     ===================================================== */
  if (typeof $.fn.slick !== 'undefined' && $('#products-slider').length) {
    $('#products-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      speed: 600,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 2 } },
        { breakpoint: 768,  settings: { slidesToShow: 1, arrows: false } }
      ]
    });
  }


  /* =====================================================
     6. SLICK SLIDER — Testimonials
     ===================================================== */
  if (typeof $.fn.slick !== 'undefined' && $('#testimonials-slider').length) {
    $('#testimonials-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 700,
      fade: true,
      cssEase: 'ease',
      prevArrow: '<button type="button" class="slick-prev custom-arrow"><i class="fal fa-long-arrow-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next custom-arrow"><i class="fal fa-long-arrow-right"></i></button>',
    });
  }


  /* =====================================================
     7. ACTIVE NAV LINK — Scroll Spy
     ===================================================== */
  const sections  = document.querySelectorAll('section[id]');
  const navLinks  = document.querySelectorAll('.nc-link');

  const updateActiveLink = () => {
    let current = '';
    sections.forEach(section => {
      const top = section.offsetTop - 140;
      if (window.scrollY >= top) {
        current = section.getAttribute('id');
      }
    });
    navLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active');
      }
    });
  };

  window.addEventListener('scroll', updateActiveLink, { passive: true });


  /* =====================================================
     8. SMOOTH SCROLL for anchor links
     ===================================================== */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        if (lenis) {
          lenis.scrollTo(target, { offset: -80 });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });


  /* =====================================================
     9. NEWSLETTER — Form Submit
     ===================================================== */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email  = document.getElementById('newsletter-email').value.trim();
      const btn    = document.getElementById('newsletter-submit');
      if (email) {
        btn.textContent = '✓ Subscribed!';
        btn.style.background = 'linear-gradient(135deg, #3D9970, #27AE60)';
        setTimeout(() => {
          btn.textContent = 'Subscribe';
          btn.style.background = '';
          newsletterForm.reset();
        }, 3000);
      }
    });
  }


  /* =====================================================
     10. FOOTER — Dynamic Year
     ===================================================== */
  const yearEl = document.getElementById('footer-year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

});
